import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '../i18n';
import { cn } from '../lib/cn';

/** `vertical` stacks the languages (md+ only) — used in the collapsed sidebar rail. */
export function LanguageSwitcher({ vertical = false }: { vertical?: boolean }) {
  const { i18n, t } = useTranslation();
  const current = (SUPPORTED_LANGUAGES as readonly string[]).includes(i18n.resolvedLanguage ?? '')
    ? (i18n.resolvedLanguage as SupportedLanguage)
    : 'en';
  return (
    <div
      className={cn(
        'flex items-center gap-1 text-xs',
        vertical && 'md:flex-col md:items-center',
      )}
      role="group"
      aria-label={t('language.label')}
    >
      {SUPPORTED_LANGUAGES.map((lng) => (
        <button
          key={lng}
          type="button"
          onClick={() => void i18n.changeLanguage(lng)}
          aria-pressed={current === lng}
          className={
            current === lng
              ? 'font-semibold text-foreground'
              : 'text-muted-foreground hover:text-foreground'
          }
        >
          {t(`language.${lng}`)}
        </button>
      ))}
    </div>
  );
}
